import React, { useState } from "react";
import { Alert, Box, Card, CircularProgress } from "@mui/material";
import { useSelector } from "react-redux";
import BannerTop from "../../components/BannerTop/BannerTop";
import { l } from "../../libs/localization";
import "./profile.style.scss";
import Button from "../../design-library/Button/Button.component";
import { forgotPwdApi } from "../../api/auth.api";

function ProfileSecurityPage() {
  const user = useSelector((state) => state.auth.user);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [sent, setSent] = useState(false);

  async function handleClick() {
    setLoading(true);
    setError(null);
    setSent(false);
    try {
      const res = await forgotPwdApi({ email: user.username });
      setLoading(false);
      if (res) {
        setSent(true);
      } else {
        setError(l("ERROR.DATA_ERROR"));
      }
    } catch (err) {
      setLoading(false);
      console.error(err);
      if (err.response?.data?.clientType) {
        setError(err.response.data.clientType);
      } else {
        setError(err.message);
      }
    }
  }

  return (
    <div className="profilePage">
      <BannerTop small variant="profile">
        <h1 className="mt-4 title">{l("PROFILE.CHANGE_PASSWORD")}</h1>
      </BannerTop>
      <Card
        sx={{
          p: 3,
          mt: -6,
          position: "relative",
          boxShadow: "0px 4px 10px 0px #00000026",
          display: "flex",
          flexDirection: "column",
          gap: 2,
          alignItems: "flex-start",
        }}
      >
        {error ? (
          <Alert severity="error" sx={{ alignSelf: "stretch" }}>
            {error}
          </Alert>
        ) : null}
        {sent ? (
          <Alert severity="success" sx={{ alignSelf: "stretch" }}>
            {l("PROFILE.CHANGE_PASSWORD_SENT")}
          </Alert>
        ) : (
          <>
            <p>{l("PROFILE.CHANGE_PASSWORD_INTRO")}</p>
            <Button type="button" onClick={handleClick}>
              {l("PROFILE.CHANGE_PASSWORD")}
            </Button>
          </>
        )}
        {loading ? (
          <Box
            sx={{
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              backgroundColor: "rgba(255, 255, 255, 0.7)",
              zIndex: 5,
            }}
          >
            <CircularProgress />
          </Box>
        ) : null}
      </Card>
    </div>
  );
}

export default ProfileSecurityPage;
